import React, { FC, useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { Classification } from "../../../../../models/classification";
import { getSettings } from "../../../../../services/get.data.service";
import isDuplicate from "../../shared/helpers/isDuplicate";
import SettingsView from "../../shared/settingsView";
import { ResultsTableRowData, SettingsParams, SettingsType } from "../types";
import ClassificationForm from "./classificationForm";

const ClassificationSettings: FC = () => {
  const { id }: SettingsParams = useParams();
  const [data, setData] = useState<Classification[] | null>([]);

  const loadData = (): void => {
    getSettings<Classification>("classifications").then((response) => {
      setData(response.data);
    });
  };

  useEffect(() => {
    loadData();
  }, []);

  const rows: ResultsTableRowData[] | null =
    data &&
    data.map((classification) => {
      return {
        id: classification.classificationId,
        data: [
          classification.name,
          <Link key={`lis-${classification.classificationId}`} to={`/settings/classifications/edit/${classification.classificationId}`}>
            Edit
          </Link>,
        ],
      };
    });
  return (
    <SettingsView
      headers={["Name", "Classifier Path", ""]}
      rows={rows}
      sortColumn={0}
      titleSingle="Classification"
      titlePlural="Classifications"
      type={SettingsType.classifications}
    >
    {data !== null && (
      <ClassificationForm 
        isDuplicate={(fieldToCheck, value): boolean=>{
          return isDuplicate(data.map((item)=>{
            return {
              id: item.classificationId,
              value: item.name,
            };
          }), value, Number(id));
        }}
        existingClassification={data?.find((classification) => classification.classificationId === Number(id))} 
        load={loadData}
      />
    )}
    </SettingsView>
  );
};
export default ClassificationSettings;
